/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { DocRetrieveResponse } from '../types/DocRetrieve';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type DocsRetrieveRequest = {} | null | undefined;
export type DocsRetrieveResponse = DocRetrieveResponse;

export type DocsRetrieveQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * GET /dmx-server/docs/{id}/
 *
 * ```yaml
 * operationId: docs_retrieve
 * description: >-
 *   You can order docs using GET param ordering_state
 *
 *   example:
 *
 *   http://localhost/dmx-server/docs_reduced/?ordering_state=CANCELED,SUBMITTED,REJECTED,ACCEPTED
 *
 *   At first all CANCELED docs, then all with state SUBMITTED, then REJECTED, etc.
 * tags:
 *   - docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DocRetrieve'
 *     description: ''
 * ```
 */
export const docsRetrieveOperation = ({ id, ...rest }: DocsRetrieveQuery) =>
  ({
    method: 'GET',
    path: `/dmx-server/docs/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/docs/{id}/' };
  };

/**
 * GET /dmx-server/docs/{id}/
 *
 * ```yaml
 * operationId: docs_retrieve
 * description: >-
 *   You can order docs using GET param ordering_state
 *
 *   example:
 *
 *   http://localhost/dmx-server/docs_reduced/?ordering_state=CANCELED,SUBMITTED,REJECTED,ACCEPTED
 *
 *   At first all CANCELED docs, then all with state SUBMITTED, then REJECTED, etc.
 * tags:
 *   - docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DocRetrieve'
 *     description: ''
 * ```
 */
export const docsRetrieve = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: DocsRetrieveQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<DocRetrieveResponse>> => {
  const operation = docsRetrieveOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/docs/{id}/
 */
export const useDocsRetrieveResource = (
  query: DocsRetrieveQuery | null,
  useCached?: boolean,
): UseResource<DocsRetrieveResponse> => {
  return useResource<DocsRetrieveResponse>({
    path: query === null ? null : docsRetrieveOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
